import "./News.css";
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { NewsItem, fetchNews } from "src/network/fetchNews";
import { imageUrl } from "src/network/fullUrl";
import image2 from "../../images/2.png";
import MoreButton from "../MoreButton";
import { useIsMobile } from "src/hooks/useIsMobile";

const News = () => {
  const [newsItems, setNewsItems] = useState<NewsItem[]>([]);
  const navigate = useNavigate();
  const { isMobile } = useIsMobile();

  useEffect(() => {
    const getNews = async () => {
      try {
        const news = await fetchNews();
        setNewsItems(news);
      } catch (error) {
        console.error("Failed to fetch news:", error);
      }
    };

    getNews();
  }, []);

  return (
    <section className="news-section">
      <div className="news">
        <div className="news-left">
          <div>
            <h2 className="dotmedico">dotmedica</h2>
            <h2 className="news-sbed">news</h2>
          </div>
          {!isMobile && (
            <MoreButton
              onClick={() => {
                navigate("/news");
              }}
            />
          )}
        </div>
        <div className="news-items">
          {newsItems.slice(0, 3).map((news, index) => (
            <div
              key={`${news?.slug}-${index}`}
              className="news-card"
              onClick={() => navigate(`/news/${news.slug}`)}
            >
              <img
                src={imageUrl(news?.main_image)}
                alt={news?.slug}
                className="news-image"
                onError={(e) => {
                  e.currentTarget.onerror = null; // Prevents infinite loop in case the fallback image is also broken
                  e.currentTarget.src = image2; // Fallback image URL
                }}
              />
              <h3>{news?.title}</h3>
            </div>
          ))}
        </div>
        {isMobile && (
            <MoreButton
              onClick={() => {
                navigate("/news");
              }}
            />
          )}
      </div>
    </section>
  );
};

export default News;
